import React, { useState } from 'react';
import clsx from 'clsx';
import { StudentPerformance } from '@/components/student-performance';
import dayjs from 'dayjs';
import '@/assets/styles/components/student-history.scss';
import { StudentMeetings } from '@/components';
import { AvailableHourResponseLiveServiceGroupEnum } from '@dopingtech/live_expert_bff_api_ts/api.ts';

interface StudentHistoryProps {
	studentId: string;
	gradeId: number;
}

const StudentHistory: React.FC<StudentHistoryProps> = ({ studentId, gradeId }) => {
	const [activeTab, setActiveTab] = useState<'meetings' | 'performance'>('meetings');

	return (
		<div className="student-history">
			<p className="student-history-title">Öğrenci Geçmişi {studentId}</p>

			<div className="student-history-tabs">
				<button
					className={clsx('student-history-tabs-item', {
						'student-history-tabs-item--active': activeTab === 'meetings'
					})}
					onClick={() => setActiveTab('meetings')}>
					Görüşmeler
				</button>
				<button
					className={clsx('student-history-tabs-item', {
						'student-history-tabs-item--active': activeTab === 'performance'
					})}
					onClick={() => setActiveTab('performance')}>
					Performans Raporu
				</button>
			</div>

			<div className="student-history-content">
				{activeTab === 'performance' && (
					<StudentPerformance
						studentId={studentId}
						gradeId={gradeId}
					/>
				)}
				{activeTab === 'meetings' && (
					<div className="student-history-meetings">
						<StudentMeetings
							liveServiceGroup={AvailableHourResponseLiveServiceGroupEnum.Coaching}
							studentId={studentId}
						/>
					</div>
				)}
			</div>
		</div>
	);
};

export default StudentHistory;
